import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M9.5 9.5V3h1v6.5H17v1h-6.5V17h-1v-6.5H3v-1h6.5z" fill="#000" /></svg>;